import Context from '../../../shared/Context';

export default class blcktiveEvent {
  constructor(component, name) {
    this.component = component;
    this.name = name;
    this.handler = null;
  }

  bind(directive) {
    const blcktive = this.component.instance;

    this.handler = blcktive.on(this.name, (...args) => {
      // watch for reproxy
      if (args[0] instanceof Context) {
        const ctx = args.shift();
        ctx.component = blcktive;
        directive.fire(ctx, args);
      } else {
        directive.fire({}, args);
      }

      // cancel bubbling
      return false;
    });
  }

  render() {}

  unbind() {
    this.handler.cancel();
  }

  unrender() {}
}
